'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselControls: ()=>CarouselControls
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_Carousel_variants_cjs_namespaceObject = require("./Carousel.variants.cjs");
const external_CarouselAutoplayButtons_cjs_namespaceObject = require("./CarouselAutoplayButtons.cjs");
const external_CarouselBlurBox_cjs_namespaceObject = require("./CarouselBlurBox.cjs");
const external_CarouselBlurBox_variants_cjs_namespaceObject = require("./CarouselBlurBox.variants.cjs");
const external_CarouselDotButton_cjs_namespaceObject = require("./CarouselDotButton.cjs");
const external_CarouselLightboxButton_cjs_namespaceObject = require("./CarouselLightboxButton.cjs");
const external_CarouselPrevNextButtons_cjs_namespaceObject = require("./CarouselPrevNextButtons.cjs");
const external_CarouselSlideNumText_cjs_namespaceObject = require("./CarouselSlideNumText.cjs");
function CarouselControls({ config, slides, selectedIndex, prevBtnDisabled, nextBtnDisabled, prevBtnHidden, onPrevButtonClick, onNextButtonClick, onDotButtonClick, onPrevNextButtonClick, onAutoplayButtonClick, toggleAutoplay, autoplayIsPlaying, slotClassNames, variantSlots, currentSlide, totalSlides }) {
    const { buttonClass = '', dotsPaginationClass = '', dotButtonClass = '', dotClass = '', blurBoxClass = '', blurBoxDividerClass = '', blurBoxNumbersClass = '', blurBoxLightboxButtonClass = '', blurBoxAutoplayButtonClass = '' } = slotClassNames;
    const prevButtonClasses = (0, cn_cjs_namespaceObject.cn)(variantSlots.prevButtonSlot(), buttonClass);
    const nextButtonClasses = (0, cn_cjs_namespaceObject.cn)(variantSlots.nextButtonSlot(), buttonClass);
    const hiddenButtonClasses = (0, cn_cjs_namespaceObject.cn)(variantSlots.hiddenButtonSlot(), buttonClass);
    const dotsPaginationClasses = (0, cn_cjs_namespaceObject.cn)(variantSlots.dotsPaginationSlot(), dotsPaginationClass);
    const dotButtonClasses = (0, cn_cjs_namespaceObject.cn)(variantSlots.dotButtonSlot(), dotButtonClass);
    const { blurBoxSlot, blurBoxDividerSlot, blurBoxNumbersSlot, blurBoxLightboxButtonSlot, blurBoxAutoplayButtonSlot } = (0, external_CarouselBlurBox_variants_cjs_namespaceObject.carouselBlurBoxVariants)({
        numbers: config.showSlideNum && !config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndLightbox: config.showSlideNum && config.showLightboxBtn && !config.showAutoplayBtn,
        numbersAndAutoplay: config.showSlideNum && config.showAutoplayBtn && !config.showLightboxBtn,
        numbersAndLightboxAndAutoplay: config.showSlideNum && config.showLightboxBtn && config.showAutoplayBtn
    });
    const blurBoxClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxSlot(), blurBoxClass);
    const blurBoxDividerClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxDividerSlot(), blurBoxDividerClass);
    const blurBoxNumbersClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxNumbersSlot(), blurBoxNumbersClass);
    const blurBoxLightboxButtonClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxLightboxButtonSlot(), blurBoxLightboxButtonClass);
    const blurBoxAutoplayButtonClasses = (0, cn_cjs_namespaceObject.cn)(blurBoxAutoplayButtonSlot(), blurBoxAutoplayButtonClass);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            config.showArrowBtns && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselPrevNextButtons_cjs_namespaceObject.CarouselPrevButton, {
                buttonClasses: prevButtonClasses,
                hiddenButtonClasses: hiddenButtonClasses,
                onClick: ()=>onPrevNextButtonClick(onPrevButtonClick),
                disabled: prevBtnDisabled,
                hidden: prevBtnHidden,
                type: config.isImageCarousel ? 'image' : 'content'
            }),
            config.showArrowBtns && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselPrevNextButtons_cjs_namespaceObject.CarouselNextButton, {
                buttonClasses: nextButtonClasses,
                onClick: ()=>onPrevNextButtonClick(onNextButtonClick),
                disabled: nextBtnDisabled,
                type: config.isImageCarousel ? 'image' : 'content'
            }),
            config.showDotBtns && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                "data-testid": "carousel-dot-buttons",
                className: dotsPaginationClasses,
                children: slides?.map((slide, index)=>{
                    const isSelected = index === selectedIndex;
                    const dotClasses = (0, cn_cjs_namespaceObject.cn)((0, external_Carousel_variants_cjs_namespaceObject.carouselVariants)().dotSlot({
                        isDotSelected: isSelected
                    }), dotClass);
                    const slideId = slide.id;
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselDotButton_cjs_namespaceObject.CarouselDotButton, {
                        onClick: ()=>config.shouldUseAutoplay ? onAutoplayButtonClick(()=>onDotButtonClick(index)) : onDotButtonClick(index),
                        dotButtonClasses: dotButtonClasses,
                        dotClasses: dotClasses
                    }, slideId);
                })
            }),
            config.showBlurBox && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_CarouselBlurBox_cjs_namespaceObject.CarouselBlurBox, {
                slotClassNames: {
                    blurBoxClasses,
                    blurBoxDividerClasses
                },
                children: [
                    config.showSlideNum && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselSlideNumText_cjs_namespaceObject.CarouselSlideNumText, {
                        numbersClasses: blurBoxNumbersClasses,
                        "data-id": "carousel-numbers-text",
                        currentSlide: currentSlide,
                        totalSlides: totalSlides
                    }),
                    config.showLightboxBtn && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselLightboxButton_cjs_namespaceObject.CarouselLightboxButton, {
                        lightboxButtonClasses: blurBoxLightboxButtonClasses,
                        "data-id": "carousel-lightbox-button"
                    }),
                    config.showAutoplayBtn && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CarouselAutoplayButtons_cjs_namespaceObject.CarouselAutoplayButton, {
                        autoplayButtonClasses: blurBoxAutoplayButtonClasses,
                        "data-id": "carousel-autoplay-button",
                        onClick: ()=>toggleAutoplay(),
                        autoplayIsPlaying: autoplayIsPlaying
                    })
                ]
            })
        ]
    });
}
exports.CarouselControls = __webpack_exports__.CarouselControls;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselControls"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
